import React, { useCallback } from 'react';
import { ErrorMessage, FormikProps } from 'formik';
import styled from 'styled-components';

import stores from '../../../../../stores';
import { StarRating } from '../../../../StarRating';
import { LabeledField } from '../../../../LabeledField';
import { TEXT_COLOR } from '../../../../../theme';
import { FORM_TEXTS } from '../../formDictionary';
import { ReviewFormValues } from '../../types';
import { ErrorMessageContainer } from '../../../../fields/common/ErrorMessageContainer';

const Title = styled.p`
  margin-bottom: 16px;
  font-size: 18px;
  line-height: 1.33;
  letter-spacing: 0.2px;
  color: ${TEXT_COLOR};
`;

type StarsStepProps = FormikProps<ReviewFormValues> & {
  firstName: string,
  examCenterTitle: string,
};

const StarsStep = ({
  errors, touched, values, firstName, examCenterTitle, handleChange, handleBlur,
}: StarsStepProps) => {
  const { starsData } = FORM_TEXTS;

  const handleStarsClick = useCallback((e) => {
    stores.examCenterReviewStore.setRating(e.target.value);
    handleChange(e);
  }, []);

  return (
    <>
      <Title>{`${firstName}, laissez un avis sur le ${examCenterTitle}`}</Title>
      <LabeledField isRequired label={starsData.label} error={errors.stars && touched.stars}>
        <StarRating
          selectedStars={values.stars}
          onStarClick={handleStarsClick}
          onBlur={handleBlur}
          name="stars"
          starsHeight={40}
          starsWidth={40}
        />
        <ErrorMessage component={ErrorMessageContainer} name="stars" />
      </LabeledField>
    </>
  );
};

export { StarsStep };
